import { useState } from 'react';
import Button from '../common/Button';
import MobileToggle from './MobileToggle';

function Header({ 
    searchTerm, 
    onSearch, 
    onShowFilters, 
    onClearFilters, 
    hasActiveFilters,
    // Mobile toggle props (only used on mobile)
    mobileView,
    onMobileViewChange
}) {
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        onSearch(localSearchTerm);
    };

    const handleClearSearch = () => {
        setLocalSearchTerm('');
        onSearch('');
    };

    return (
        <header className="gw-bp-geosearch-header">
            <div className="search-section">
                <form onSubmit={handleSearchSubmit} className="search-form">
                    <div className="search-input-wrapper">
                        <input
                            type="text"
                            value={localSearchTerm}
                            onChange={(e) => setLocalSearchTerm(e.target.value)}
                            placeholder="Search members..."
                            className="search-input"
                        />
                        {localSearchTerm && (
                            <button
                                type="button"
                                onClick={handleClearSearch}
                                className="clear-search-btn"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        )}
                    </div>
                    <Button type="submit" variant="primary">
                        Search
                    </Button>
                </form>
            </div>

            <div className="controls-section">
                <Button
                    onClick={onShowFilters}
                    variant={hasActiveFilters ? "primary" : "secondary"}
                    className={hasActiveFilters ? "has-active-filters" : ""}
                >
                    Filters {hasActiveFilters && <span className="filter-indicator">•</span>}
                </Button>

                {mobileView !== undefined && (
                    <MobileToggle 
                        currentView={mobileView}
                        onViewChange={onMobileViewChange}
                    />
                )}

                {(hasActiveFilters || searchTerm) && (
                    <Button
                        onClick={onClearFilters}
                        variant="outline"
                        size="small"
                    >
                        Clear All
                    </Button>
                )}
            </div>
        </header>
    );
}

export default Header;
